export const TrueFalseEnum = {
    YES: 1,
    NO: 0,
}
